(window as any).onYouTubeIframeAPIReady = function () {
    const ytElement = document.getElementById("heroYoutube");

    if (ytElement) {
        const videoId = ytElement.getAttribute("data-youtube-id");

        var player = new YT.Player('heroYoutube', {
            //video id and playlist id will come from Episerver Youtube field
            videoId: videoId, //UBqAJJRMerM - venue YouTube Video ID          // Player height (in px)
            playerVars: {
                autoplay: 1,        // Auto-play the video on load
                controls: 0,        // Hide buttons in player
                showinfo: 0,        // Hide the video title
                rel: 0,
                modestbranding: 1,  // Hide the Youtube Logo
                loop: 1,            // Run the video in a loop
                fs: 0,              // Hide the full screen button 
                iv_load_policy: 3,  // Hide the Video Annotations
                autohide: 0,         // Hide video controls when playing
                playlist: videoId
            },
            events: {
                onReady: function (e) {
                    e.target.mute();
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/youtube-hero.ts